// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__o2SUN","contactTitle":"Contact_contactTitle__s+gDn","contactDescription":"Contact_contactDescription__sQnU2"};